import { connect } from 'react-redux'
import i18next from 'i18next'
import Config from 'config'
import { setPopupScreen, uiButtonPressed } from '../../redux/actions'
import Bet from '../settings/bet'
import BetArea from '../controls/BetArea'
import TitleBar from './TitleBar'
import { getBet } from '../../utils'
import { BUTTON_CLOSE } from '../../redux/constants'

const BetPopup = props => {
  const {
    sideGames,
    betAmount,
    dimensions,
    setPopupScreen,
    svgIcons,
    formatStyle,
    smartLandscapeWidthCoef,
    uiButtonPressed,
  } = props
  const { desktopUI, portrait, availableWidth } = dimensions
  const quickspinEnabled = Config.FEATURE_CONFIG.QUICKSPIN

  const onCloseIconClick = () => {
    setPopupScreen(null)
    uiButtonPressed(BUTTON_CLOSE)
  } 

  const betAreaProps = {
    value: getBet(sideGames, betAmount),
    dimensions,
    svgIcons,
    formatStyle,
  }
  let betContentsWidth = 'auto'
  if (!desktopUI) {
    betContentsWidth = portrait ? '100%' : availableWidth * smartLandscapeWidthCoef
  }
  return (
    <div className={`bet-wrapper${quickspinEnabled ? '' : ' no-quickspin'}`}>
      <div
        className='bet-contents'
        style={{ width: betContentsWidth }}
      >
        {desktopUI
          ? <Bet formatStyle={formatStyle} />
          : (
            <React.Fragment>
              <div className='title-wrapper'>
                <TitleBar
                  titleText={i18next.t('gameControl.bet')}
                  svgIcons={svgIcons}
                  closeIconAdditionalClass='bet-close'
                  onCloseIconClick={onCloseIconClick}
                />
              </div>
              <div className="main-wrapper">
                <div className="main-content">
                  <div className="bet-description">{i18next.t('settings.bet.chooseBetAmount')}</div>
                  <BetArea {...betAreaProps} />
                </div>
                <div className="show-advanced"></div>
              </div>
            </React.Fragment>
          )
        }
      </div>
    </div>
  )
}

export default connect(state => ({
  sideGames: state.base.sideGames,
  dimensions: state.UI.dimensions,
  betAmount: state.session.betAmount,
}), { setPopupScreen, uiButtonPressed })(BetPopup)